import { IAutomaticSpecialSituationValidation } from "../interface/automaticSpecialSituation/IAutomaticSpecialSituationValidation";
import { ApiService } from "../model/Api.model";
import { AxiosInstance } from "axios";

enum AutomaticSpecialSituationValidationServiceEnum {
  isSpecialSituationValid = "/is-special-situation-valid/",
  getAutomaticSpecialSituationValidation = "/special-situation-validations/"
}

export default class AutomaticSpecialSituationValidationService extends ApiService {
  constructor(restClient: AxiosInstance) {
    super(restClient, "/automatic-special-validation");
  }

  public isSpecialSituationValid = async (tradeId: number) => await this.GET(AutomaticSpecialSituationValidationServiceEnum.isSpecialSituationValid + tradeId);


  public automaticSpecialSituationValidation = async (tradeId: number, isLegalDiligence: boolean = false): Promise<IAutomaticSpecialSituationValidation[]> =>
    await this.GET(
      `${AutomaticSpecialSituationValidationServiceEnum.getAutomaticSpecialSituationValidation}${tradeId}?isLegalDiligence=${isLegalDiligence}`
    );
};

